if (!customElements.get('product-form-buy-now')) {
  customElements.define(
    'product-form-buy-now',
    class ProductFormBuyNow extends customElements.get('product-form') {
      constructor() {
        super();
      }

      syncQuantityInput() {
        const quantityInput = document.getElementById(`Quantity-${this.dataset.sectionId}`);
        if (!quantityInput) return;

        let hiddenInput = this.form.querySelector('input.buy-now-quantity');
        if (!hiddenInput) {
          hiddenInput = document.createElement('input');
          hiddenInput.type = 'hidden';
          hiddenInput.name = 'quantity';
          hiddenInput.className = 'buy-now-quantity';
          this.form.appendChild(hiddenInput);
        }
        hiddenInput.value = quantityInput.value;
      }

      onSubmitHandler(evt) {
        this.syncQuantityInput();

        if (this.dataset.redirectToCheckout !== 'true') {
          super.onSubmitHandler(evt);
          return;
        }

        // Buy-now checkout flow: add to cart then redirect
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = new FormData(this.form);

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }
            let redirected = false;
            const toCheckout = () => {
              if (redirected) return;
              redirected = true;
              window.location.href = '/checkout';
            };
            setTimeout(toCheckout, 1500);
            try {
              const items = Array.isArray(response.items) ? response.items : [response];
              window.dataLayer = window.dataLayer || [];
              window.dataLayer.push({
                event: window.AP_PENDING_EVENTS.PRD,
                ap_ecomm_currency: window.AP_ECOMM_CURRENCY,
                ap_order_prds: items.map((item) => window.transformCartItemToProduct(item)),
                eventCallback: toCheckout,
                eventTimeout: 1000,
              });
            } catch (e) {
              console.error('send window.AP_PENDING_EVENTS.PRD error:', e);
              toCheckout();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }
    }
  );
}
